import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "hsl(40 50% 97%)",
            border: "1px solid hsl(4 42% 55% / 0.4)",
            color: "hsl(28 22% 16%)",
            fontFamily: "Karla, sans-serif",
            borderRadius: "14px",
          },
        }}
      />
    </div>
  );
}

export default App;
